<template>
  <td v-if="version === 'table'">
    <img
      v-if="allImages.length"
      :src="fullImageUrl(lead.id, allImages[0])"
      :data-images="allImages"
      :data-photo-url="`${preparedImagesHost}${lead.id}/`"
      class="img-fluid-table"
      @click="onImageClick"
    />
    <img v-else :src="imagePlaceholderUrl" class="img-fluid-table" />
  </td>

  <div
    v-if="version === 'print' && allImages.length && template === 'one'"
    class="d-flex template-one"
  >
    <div class="main-image nobreak">
      <a href="#">
        <img :src="fullImageUrl(lead.id, allImages[0])" class="img-fluid" />
      </a>
    </div>
  </div>

  <div
    v-if="version === 'print' && allImages.length && template === 'all'"
    class="d-flex template-all"
  >
    <div
      v-for="image of allImages"
      :key="image"
      class="main-image mb-1 nobreak"
    >
      <img :src="fullImageUrl(lead.id, image)" class="img-fluid" />
      <span />
    </div>
  </div>

  <div
    v-if="version === 'print' && allImages.length && template === 'little'"
    class="d-flex template-little"
  >
    <div class="main-image">
      <a href="#">
        <img
          :src="fullImageUrl(lead.id, allImages[0])"
          class="nobreak img-fluid"
        />
      </a>
    </div>
    <div
      ref="masonryWrapper"
      class="masonry-wrapper"
      :id="`masonry-wrapper-${lead.id}`"
    >
      <div
        v-for="image of allImages.filter((_, imgIdx) => imgIdx !== 0)"
        :key="image"
        class="secondary-image masonry-item nobreak"
      >
        <a href="#">
          <img :src="fullImageUrl(lead.id, image)" class="img-fluid" />
        </a>
      </div>
    </div>
  </div>

  <div
    v-if="
      version === 'print' &&
      allImages.length &&
      !['one', 'little', 'all'].includes(template)
    "
    class="d-flex"
  >
    <div class="main-image nobreak">
      <a href="#">
        <img :src="fullImageUrl(lead.id, allImages[0])" class="img-fluid" />
      </a>
    </div>
  </div>

  <div v-if="version === 'print' && !allImages.length" class="d-flex">
    <div class="main-image">
      <a href="#">
        <img :src="imagePlaceholderUrl" class="nobreak img-fluid" />
      </a>
    </div>
  </div>

  <div v-if="version === 'standard'">
    <div class="standart-tabs" :style="tabStyles" v-if="images.length > 1">
      <div
        :class="getTabBtnClass(idx)"
        v-for="(imagesField, idx) of standartImages"
        :key="`field_${idx}`"
        @click="changeSwiperImages(idx)"
      >
        <div class="ww-tab-name" :title="imagesField.name">
          {{ imagesField.name }}
        </div>
      </div>
    </div>
    <Swiper
      v-for="(imagesField, idx) of images"
      :key="idx"
      :imageId="idx"
      :class="currentSwiperImages === idx ? '' : 'ww-inactive-tab'"
      :imagesHost="preparedImagesHost"
      :leadId="lead.id"
      :images="imagesField.images"
      :videoField="videoField"
      :positionVideo="this.config.positionVideo"
      :galleryOption="config.galleryOption"
      :isActive="currentSwiperImages === idx"
    />
  </div>
</template>

<script>
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox.css'
import Swiper from './Swiper.vue'
import { metrikaEvents } from '../../../../services/metrika'

export default {
  name: 'Images',
  props: {
    lead: Object,
    config: Object,
    version: String,
    agent: Object,
  },
  components: {
    Swiper,
  },
  computed: {
    cfs() {
      return this.lead?.custom_fields_values
    },
    videoField() {
      return this.cfs?.find((field) => field.field_id === this.config.videoId)
    },
    template() {
      return this.config.template
    },
    allImages() {
      return this.images.map((i) => i.images).flat()
    },
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    swiperImages() {
      return this.images[this.currentSwiperImages] || []
    },
    images() {
      const images = this.config.images
        .map((i) => this.getImagesFromCf(i.id))
        .filter((i) => Boolean(i) && i.images.length)

      if (!images.length) {
        const newImages = this.version === 'standard' ? ['not_images'] : []
        images.push({ name: 'Изображения', images: newImages })
      }

      if (this.version !== 'standard') {
        return images
      }

      if (this.videoField) {
        const videoUrl = this.videoField.values[0].value
        if (this.config.positionVideo === 'first') {
          images[0].images.unshift(videoUrl)
        } else {
          images[0].images.push(videoUrl)
        }
      }

      return images
    },
    standartImages() {
      return this.images.filter((_, i) => {
        const count = this.isMobileVersion ? 3 : 5
        return i < count + 1
      })
    },
    tabStyles() {
      const repeat = this.isMobileVersion ? this.standartImages.length : 5
      return {
        'grid-template-columns': `repeat(${repeat}, 1fr)`,
      }
    },
    imagePlaceholderUrl() {
      return '/images/Photo.png'
    },
    preparedImagesHost() {
      const host = this.config.imagesHost
      return !host.includes('cdn') || this.agent
        ? host
        : host.replace(
            /(?<first>https:\/\/.*?cdn\.winwinapp.ru\/)images(?<end>\/.*)/gm,
            '$<first>images/an$<end>',
          )
    },
  },
  methods: {
    getTabBtnClass(idx) {
      return {
        'tab-btn': true,
        'tab-btn--inactive': idx !== this.currentSwiperImages,
      }
    },
    changeSwiperImages(idx) {
      const from = this.standartImages[this.currentSwiperImages]?.name
      const to = this.standartImages[idx]?.name
      metrikaEvents.onChangeImagesTab(from, to)
      this.currentSwiperImages = idx
    },
    getImagesFromCf(cfId) {
      const imagesField = this.cfs?.find((cf) => cf.field_id === cfId)
      if (!imagesField) return
      const images = imagesField
        ? Object.keys(JSON.parse(imagesField.values[0].value))
        : []

      return { name: imagesField.field_name, images }
    },
    onImageClick({ target: imageCell }) {
      const { photoUrl, images } = imageCell.dataset
      const fancyboxImages = images.split(',').map((image) => ({
        src: `${photoUrl}${image}`,
        type: 'image',
      }))
      Fancybox.show(fancyboxImages, { infinite: false })
    },
    fullImageUrl(leadId, imageUrl) {
      const image = imageUrl || ''
      return image.includes('http')
        ? image
        : `${this.preparedImagesHost}${leadId}/${imageUrl}`
    },
  },
  data() {
    return {
      currentSwiperImages: 0,
    }
  },
}
</script>

<style scoped>
/* табличное отображение */
.img-fluid-table {
  width: 100px;
  height: auto;
  cursor: pointer;
}

.standart-tabs {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.tab-btn {
  border: 1px solid #918b8b;
  background-color: #0092ff;
  color: white;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  cursor: pointer;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-weight: 500;
}
.tab-btn--inactive {
  background-color: white;
  color: black;
}
.ww-inactive-tab {
  height: 0;
  overflow: hidden;
}
.ww-tab-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 10px;
}
</style>
